import React from 'react';

// Logo component with yellow text on black rounded square
const Logo = ({ size = 'medium', isDarkMode = false }) => {
  const sizes = {
    small: {
      svg: { width: 60, height: 60 },
      fontSize: 16
    },
    medium: {
      svg: { width: 110, height: 110 },
      fontSize: 28
    },
    large: {
      svg: { width: 200, height: 200 },
      fontSize: 28
    }
  };
  
  const config = sizes[size];
  
  return (
    <svg
      width={config.svg.width}
      height={config.svg.height}
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Recall It"
    >
      <rect width="100" height="100" rx="20" fill="#0E0E0E"/>
      <text
        x="50"
        y="50"
        fontFamily="Arial,sans-serif"
        fontSize={config.fontSize}
        fontWeight="bold"
        fill="#fdf171"
        textAnchor="middle"
      >
        Recall
      </text>
      <text
        x="50"
        y="75"
        fontFamily="Arial,sans-serif"
        fontSize={config.fontSize}
        fontWeight="bold"
        fill="#fdf171"
        textAnchor="middle"
      >
        It
      </text>
      {size === 'large' && (
        <text
          x="103"
          y="103"
          fontFamily="Arial,sans-serif"
          fontSize="12"
          fontWeight="bold"
          fill={isDarkMode ? "#fdf171" : "#0E0E0E"}
          textAnchor="middle"
        >
          ™
        </text>
      )}
    </svg>
  );
};

export default Logo;
